// Initialize Stripe with your publishable key
const stripe = Stripe('pk_test_51NrV1xBKOzfRIrJcnwgoodvnhlDvUw1R73Vbvb6nHan6LyLH8AP142KMhbtDIMTcucyfKjN83Y0nT7jMF94Eozbh00ksbqLQmx');

document.addEventListener('DOMContentLoaded', function () {
    const paymentFields = document.querySelectorAll('[id$="_card_element"]');

    paymentFields.forEach(function (cardElementDiv) {
        const fieldName = cardElementDiv.id.replace('_card_element', '');
        const form = cardElementDiv.closest('form');

        if (!form) return;

        // Fields
        const categoryDropdown = form.querySelector(`[name="${fieldName}_Payment_CategoryID"]`);
        const dropdownField = form.querySelector(`[name="${fieldName}_Payment_AmountID"]`);
        const amountField = form.querySelector(`[name="${fieldName}_Payment_Amount"]`);
        const tokenField = form.querySelector(`[name="${fieldName}_Token"]`);
        const errorDiv = document.getElementById(`${fieldName}_card_errors`);
        const paymentMethodRadios = form.querySelectorAll(`[name="${fieldName}_Payment_Method"]`);
        const paymentMethod = form.querySelectorAll(`input.payment.payment-method`);
        const paymentCategory = form.querySelectorAll(`input.payment.payment-category`);
        const paymentAmount = form.querySelectorAll(`input.payment.payment-amount`);
        let chosenPaymentAmount = null;

        // console.log('fieldName', fieldName);
        // console.log('categoryDropdown', categoryDropdown);
        // console.log('amountDropdown', amountDropdown);
        // console.log('amountField', amountField);


        // --- Parse grouped amounts ---
        const groupedAmounts = JSON.parse(amountField.getAttribute('data-grouped-amounts') || '{}');

        // console.log('groupedAmounts', groupedAmounts);

        // --- Set default payment method ---
        // if (paymentMethodRadios.length > 0) {
        //     paymentMethodRadios.forEach(radio => {
        //         radio.checked = radio.value === 'card';
        //     });
        // }

        paymentMethod.value = 'card';
        paymentMethod[0].value = 'card';

        // --- Helper: populate dropdown for a category ---
        function populateAmountDropdown(categoryID) {
            if (!dropdownField) return;

            dropdownField.innerHTML = '';
            dropdownField.options.add(new Option('Select payment option', ''));

            const categoryData = groupedAmounts[categoryID] || {};
            const amounts = categoryData.amounts || {};

            for (const amountID in amounts) {
                dropdownField.options.add(new Option(amounts[amountID]['label'], amountID));
                // console.log('amounts[amountID]', amounts[amountID]);
            }

            // Clear hidden amount field
            amountField.value = '';

            // console.log(dropdownField);
            // console.log('paymentCategoryEle', paymentCategory[0]);

            // --- Set default payment method ---
            // if (paymentMethodRadios.length > 0) {
            //     paymentMethodRadios.forEach(radio => {
            //         radio.checked = radio.value === 'card';
            //     });
            // }

            paymentCategory.value = categoryDropdown.options[categoryDropdown.selectedIndex].text;
            paymentCategory[0].value = categoryDropdown.options[categoryDropdown.selectedIndex].text;
        }

        // --- Initialize dropdowns ---
        let initialCategory = categoryDropdown ? categoryDropdown.value : Object.keys(groupedAmounts)[0];
        if (dropdownField) populateAmountDropdown(initialCategory);

        // --- Category change ---
        if (categoryDropdown) {
            categoryDropdown.addEventListener('change', function () {
                const selectedCategory = this.value;
                populateAmountDropdown(selectedCategory);
            });
        }

        // --- Dropdown change ---
        if (dropdownField) {
            dropdownField.addEventListener('change', function () {
                const selectedCategory = categoryDropdown ? categoryDropdown.value : Object.keys(groupedAmounts)[0];
                const amounts = (groupedAmounts[selectedCategory] || {}).amounts || {};
                amountField.value = amounts[this.value].amount || '';
                chosenPaymentAmount = amounts[this.value].label;

                // Format as NZD currency
                const formatter = new Intl.NumberFormat('en-NZ', {
                    style: 'currency',
                    currency: 'NZD'
                });

                paymentAmount.value = formatter.format(amountField.value);
                paymentAmount[0].value = formatter.format(amountField.value);
            });
        }

        // --- Determine if single-option payment ---
        const isSingleOption = !dropdownField || dropdownField.type === 'hidden';
        let singleAmountValue = isSingleOption ? amountField.value : null;

        // Stripe setup
        const elements = stripe.elements();
        let card = elements.create('card', {
            style: {
                base: {
                    fontSize: '16px',
                    color: '#32325d',
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                    '::placeholder': {color: '#aab7c4'}
                },
                invalid: {color: '#fa755a', iconColor: '#fa755a'}
            }
        });

        card.mount(`#${fieldName}_card_element`);

        card.on('change', function (event) {
            errorDiv.textContent = event.error ? event.error.message : '';
        });

        $(form).validate({
            rules: {
                tokenField: {
                    required: true
                }
            }
        });

        // --- Payment method toggle ---
        function updatePaymentMethodDisplay() {
            let selectedMethod = 'card';
            if (paymentMethodRadios && paymentMethodRadios.length) {
                paymentMethodRadios.forEach(radio => {
                    if (radio.checked) selectedMethod = radio.value;
                });
                cardElementDiv.closest('.payment-card-wrapper').style.display = selectedMethod === 'invoice' ? 'none' : 'block';
            }

            paymentMethod.value = selectedMethod;
            paymentMethod[0].value = selectedMethod;

            return selectedMethod;
        }

        if (paymentMethodRadios && paymentMethodRadios.length) {
            paymentMethodRadios.forEach(radio => radio.addEventListener('change', updatePaymentMethodDisplay));
        }

        // --- Handle form submit ---
        form.addEventListener('submit', async function (event) {
            event.preventDefault();

            let formValidationResults;

            await paymentFormValidation(form).then(function (response) {
                formValidationResults = JSON.parse(JSON.stringify(response));
            });

            if (formValidationResults.valid === false) {
                errorDiv.textContent = formValidationResults.message;
                return;
            }

            const submitButton = form.querySelector('[type="submit"]');
            submitButton.disabled = true;
            submitButton.textContent = 'Processing...';

            const selectedMethod = updatePaymentMethodDisplay();

            // Determine final amount
            let finalAmount = amountField.value;
            if (isSingleOption && singleAmountValue) {
                finalAmount = singleAmountValue;
            }

            let results;

            if (selectedMethod === 'invoice') {
                // let data = JSON.stringify({
                //     amount: finalAmount,
                //     description: 'Payment',
                //     paymentChoice: chosenPaymentAmount,
                //     email: form.querySelector('input.email.payment-email').value || ''
                // });
                //
                // // No Stripe payment needed
                // await createInvoice(data).then(function (response) {
                //     results = JSON.parse(JSON.stringify(response));
                // });

                // if (!results.success) {
                //     errorDiv.textContent = stripeError.message;
                // } else if (results.success === true) {
                form.submit();

                setTimeout(function () {
                    window.location.href = '/thank-you';
                });
                // }

                return;
            }

            let data = JSON.stringify({
                amount: finalAmount,
                description: 'Payment',
                email: form.querySelector('input.email.payment-email').value || ''
            })

            await getPaymentIntentResults(data).then(function (response) {
                results = JSON.parse(JSON.stringify(response));
            });

            const {client_secret, success} = results;

            if (!success || !client_secret) {
                throw new Error('Failed to create payment intent.');
            }

            const {
                error: stripeError,
                paymentIntent
            } = await stripe.confirmCardPayment(client_secret, {payment_method: {card: card}});

            if (stripeError) {
                errorDiv.textContent = stripeError.message;
            } else if (paymentIntent.status === 'succeeded') {
                tokenField.value = paymentIntent.id;
                form.submit();
            }
        });
    });
});

function paymentFormValidation(form) {
    return new Promise(function (resolve, reject) {
        let response;

        // VALIDATE THE FORM FIRST
        let isValid = true;
        let firstInvalidField = null;
        let errorTextContent = '';
        let data = {};

        // In your form validation
        const checkboxGroups = form.querySelectorAll('.requiredField.optionset');

        checkboxGroups.forEach(group => {
            const checkboxes = group.querySelectorAll('input[type="checkbox"]');
            const isChecked = Array.from(checkboxes).some(cb => cb.checked);
            const checkboxGroupsParent = group.closest('.field.optionset');

            if (!isChecked) {
                isValid = false;
                checkboxGroupsParent.classList.add('error');
                group.classList.add('error');

                // Add error message
                let errorMsg = checkboxGroupsParent.querySelector('.error-message');
                if (!errorMsg) {
                    errorMsg = document.createElement('span');
                    errorMsg.className = 'message error error-message';
                    errorMsg.textContent = 'Please select at least one option';
                    errorMsg.style.display = 'block';
                    checkboxGroupsParent.appendChild(errorMsg);
                }
            }
        });

        // Check all required fields
        const requiredFields = form.querySelectorAll('[required], fieldset.requiredField, ul.requiredField .required input, .required select, .required textarea');

        console.log(requiredFields);

        requiredFields.forEach(field => {
            // Skip our payment fields - we'll validate those separately
            if (field.name.includes('_Token') || field.name.includes('_AmountID')) {
                return;
            }

            let value = field.value ? field.value.trim() : '';

            if (field.classList.contains('optionset') || field.classList.contains('industries')) {
                const isChecked = field.querySelector('input[type="checkbox"]:checked');
                field.name = field.id

                if (!isChecked) {
                    isValid = false;
                    field.classList.add('error');
                } else {
                    let choices = {};

                    $(field).find('input[type="checkbox"]:checked').each(function () {
                        choices[this.value] = this.checked;
                    });

                    value = JSON.stringify(choices);
                }
            }

            if (!value) {
                isValid = false;
                field.classList.add('error');

                if (!firstInvalidField) {
                    firstInvalidField = field;
                }
            } else {
                field.classList.remove('error');
            }

            // Add to the object
            data[field.name] = value;
        });

        // After all validation, if there's an error
        if (!isValid && firstInvalidField) {
            // Find which step/page the error is on
            const errorStep = firstInvalidField.closest('[class*="step-"]');

            if (errorStep) {
                // Extract step number from class (e.g., "step-1", "step-2")
                const stepClasses = errorStep.className.match(/step-(\d+)/);
                const stepNumber = stepClasses ? stepClasses[1] : null;

                if (stepNumber) {
                    // Find the form and step buttons
                    const errorForm = firstInvalidField.closest('form');
                    const errorStepButtons = $(errorForm).find('.userform-progress .step-buttons .step-button-wrapper');

                    // Find and activate the correct step button
                    errorStepButtons.each(function() {
                        const button = $(this).find('[data-step]');

                        if (button.attr('data-step') === stepNumber) {
                            // Remove current from all buttons and steps
                            errorStepButtons.removeClass('current');
                            form.querySelectorAll('[class*="step-"]').forEach(step => {
                                step.classList.remove('current');
                            });

                            // Add current to this button and show the step
                            $(this).addClass('current');
                            errorStep.classList.add('current');
                            errorStep.style.display = 'block';

                            // Trigger the button click if it has a click handler
                            button.trigger('click');

                            return false; // Break the loop
                        }
                    });
                }
            }

            // Wait for step transition, then scroll to error
            setTimeout(() => {
                firstInvalidField.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });

                // Focus the first input/checkbox
                const firstInput = firstInvalidField.querySelector('input, select, textarea, input[type="checkbox"]');
                if (firstInput) {
                    firstInput.focus();
                }
            }, 400);

            // Resolve with validation failure (don't reject)
            resolve({
                valid: false,
                message: 'Please fill in all required fields correctly before processing payment.'
            });
        }

        // Convert to JSON string at the end if needed
        const jsonString = JSON.stringify(data);
        console.log(jsonString);

        $.ajax({
            url: '/make-payment/validatePaymentForm',
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            dataType: 'json',
            data: jsonString,
            success: function (response) {
                if (response.valid) {
                    resolve(response);
                } else {
                    // Show validation errors
                    let errorMessage = 'Please correct the following errors:\n';
                    response.errors.forEach(error => {
                        errorMessage += '- ' + error.message + '\n';
                    });
                    reject(errorMessage);
                }
            },
            error: function (xhr, status, error) {
                // console.error('AJAX error:', xhr.responseText);
                reject('An error occurred while validating the form');
            }
        });
    });
}

// function createInvoice(data) {
//     return new Promise(function (resolve, reject) {
//         let response;
//
//         $.ajax({
//             url: '/make-payment/createInvoice',
//             method: 'POST',
//             headers: {'Content-Type': 'application/json'},
//             dataType: 'json',
//             data: data,
//             success: function (data) {
//                 response = JSON.parse(JSON.stringify(data));
//                 resolve(response)
//             },
//             error: function (xhr, status, error) {
//                 reject(error);
//             }
//         });
//     });
// }

function getPaymentIntentResults(data) {
    return new Promise(function (resolve, reject) {
        let response;

        $.ajax({
            url: '/make-payment/createIntent',
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            dataType: 'json',
            data: data,
            success: function (data) {
                response = JSON.parse(JSON.stringify(data));
                resolve(response)
            },
            error: function (xhr, status, error) {
                reject(error);
            }
        });
    });
}
